import { Methods } from 'types/request.ts'
import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'
import { log } from 'utils/logging.ts'
import { Criticality, Flow, Severity } from 'types/logging.ts'
import { ERROR_CODES, MagicTokensExchangeRequestBody, MagicTokensExchangeResponseBody } from '@boltenergy-be/shared'
import { MAGIC_TOKEN_EXCHANGE_PATH } from 'constants/auth.ts'

export const exchangeMagicTokens = async (magicToken: string): Promise<MagicTokensExchangeResponseBody | undefined> => {
  try {
    if (!magicToken) {
      throw new Error('Magic token is missing')
    }

    const res = await newRequest<MagicTokensExchangeResponseBody>(
      getAxiosRequestConfigBoltBackend(Methods.POST, MAGIC_TOKEN_EXCHANGE_PATH, { magicToken } satisfies MagicTokensExchangeRequestBody)
    )

    if (!res.success || !res.data) {
      const isHandled = res.errorCode === ERROR_CODES.unauthorized || res.errorCode === ERROR_CODES.expired

      log({
        error: res?.message || 'unknown error for magic token exchange',
        identifier: `[${Flow.AUTH}:magicLink${res?.errorCode ? `:${res.errorCode}` : ''}]`,
        errorCode: res?.errorCode,
        severity: isHandled ? Severity.WARNING : Severity.ERROR,
        criticality: isHandled ? Criticality.LOW : undefined
      })
      return undefined
    }

    return res.data
  } catch (error) {
    log({
      error: error instanceof Error ? error : 'unknown error for magic token exchange',
      identifier: `[${Flow.AUTH}:CATCH:magicLink]`
    })
    return undefined
  }
}
